import { useQuery } from '@tanstack/react-query';

import FormSubmitError from 'errors/FormSubmitError';
import API from 'services/api';
import BidEntryDto from 'types/api/BidEntryDto';
import { AxiosError } from 'axios';

export const fetchRfpBidHistory = async (rfpId: number, elementId: number): Promise<BidEntryDto[]> => {
  try {
    const { data: entries } = await API.get<BidEntryDto[]>(`/rfp/${rfpId}/element/${elementId}/bid-history`);

    return entries;
  } catch (e) {
    let message = 'An error occurred while sending request to the server. Please try again.';

    if (e instanceof AxiosError && e.response?.data.error_message !== undefined) {
      message = e.response.data.error_message;
    }

    throw new FormSubmitError(message);
  }
};

const getQueryKey = (id?: number, elementId?: number) => {
  const keys: unknown[] = ['rfp/bidHistory'];

  if (id !== undefined) {
    keys.push(id);
  }

  if (elementId !== undefined) {
    keys.push(elementId);
  }

  return keys;
};

const useRfp = (rfpId: number, elementId: number) =>
  useQuery<BidEntryDto[], FormSubmitError>(getQueryKey(rfpId, elementId), () => fetchRfpBidHistory(rfpId, elementId), {
    retry: 0,
  });

useRfp.getQueryKey = getQueryKey;
useRfp.queries = {
  fetchRfpBidHistory,
} as const;

export default useRfp;
